<div class="mx-2 my-4 mx-lg-4 card">
  <table class="table table-striped table-hover table-responsive-xl">
    <thead>
      <tr>
        <th [tableOrderGroup]="params.sorting" [(tableOrder)]="params.sorting.nomeFantasia" (tableOrderChange)="changeOrder()" class="text-center">Unidade Cliente</th>
        <th class="text-center">Quantidade Auditores</th>
        <th width="150px" class="text-center">Ações</th>
      </tr>
      <tr>
        <th class="py-1 px-2"><input type="text" class="form-control text-uppercase"></th>
        <th class="py-1 px-2"></th>
        <th class="py-1 px-2"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="listaResultado.length==0">
        <td class="text-center py-5 text-secondary w-500" colspan="10">
          Sem registros
        </td>
      </tr>
      <tr *ngFor="let u of listaResultado">
        <td class="text-center">{{ u.nomeFantasia }}</td>
        <td class="text-center">{{ u.total }}</td>
        <td class="py-1">
          <div class="d-flex align-items-center justify-content-center">
            <button (click)="editar(u.id)" class="btn btn-sm btn-icon btn-success" title="Adicionar">
              <i class="mdi mdi-plus"></i>
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
  <div class="card-footer bg-white row justify-content-between">
    <div class="pb-2 pb-sm-0">
      <ngb-pagination [pageSize]="params.per_page" [boundaryLinks]="true" [collectionSize]="total" [(page)]="params.page" (pageChange)="nextPage()" [maxSize]="5" [rotate]="true">
      </ngb-pagination>
    </div>
    <div class="pb-2 pb-sm-0">
      <div class="btn-group" role="group">
        <button [disabled]="total==0" (click)="setPageSize(10)" [ngClass]="{'active':  params.per_page==10}" type="button" class="btn btn-outline-primary">10</button>
        <button [disabled]="total==0" (click)="setPageSize(25)" [ngClass]="{'active':  params.per_page==25}" type="button" class="btn btn-outline-primary">25</button>
        <button [disabled]="total==0" (click)="setPageSize(50)" [ngClass]="{'active':  params.per_page==50}" type="button" class="btn btn-outline-primary">50</button>
        <button [disabled]="total==0" (click)="setPageSize(100)" [ngClass]="{'active': params.per_page==100}" type="button" class="btn btn-outline-primary">100</button>
      </div>
    </div>
  </div>
</div>